module.exports = __webpack_public_path__ + "static/media/flask.14dc5679.png";